import { useContext } from 'react'
import { motion } from 'framer-motion'
import { RouteTransitionContext } from '../../components/AnimatedRoutes'

const stagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
}

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.38, 0.005, 0.215, 1] as const,
    },
  },
}

export default function PricingHero() {
  const isTransitioning = useContext(RouteTransitionContext)

  return (
    <section className="bg-oak-cream px-6 pt-32 pb-20 md:pt-44 md:pb-28">
      <motion.div
        className="mx-auto max-w-5xl text-center"
        variants={stagger}
        initial="hidden"
        animate={!isTransitioning ? 'visible' : 'hidden'}
      >
        <motion.span
          variants={fadeUp}
          className="text-sm font-semibold uppercase tracking-widest text-gold-500"
        >
          Pricing
        </motion.span>

        <motion.h1
          variants={fadeUp}
          className="mx-auto mt-4 max-w-[700px] font-serif text-[clamp(40px,7vw,96px)] leading-[0.9] tracking-[-2px] text-oak-black"
        >
          Pricing that scales with you
        </motion.h1>

        <motion.p
          variants={fadeUp}
          className="mx-auto mt-6 max-w-[440px] text-[clamp(16px,1.8vw,22px)] font-medium leading-[1.4] tracking-[-0.3px] text-oak-black/60 md:mt-8"
        >
          Straightforward plans, no hidden fees.
        </motion.p>
      </motion.div>
    </section>
  )
}
